export enum SubscriptionTiers {
  Elite = 'CHAS Elite',
  Advanced = 'CHAS Advanced',
  Standard = 'CHAS Standard',
  VerifiedContractor = 'CHAS Verified Contractor',
  VerifiedSupplier = 'CHAS Verified Supplier',
  Foundation = 'CHAS Foundation',
  Care = 'Care'
}

export enum SubscriptionTypePublicId {
  ChasEliteAU = -110,
  ChasVerifiedSupplierAU = -108,
  ChasVerifiedContractorAU = -109,
  ChasVerifiedSupplierGB = -100,
  ChasAdvanced = -103,
  ChasElite = -104,
  ChasStandard = -102,
  ChasVCS = -105,
  ChasFoundation = -101,
  ChasSocialValue = -107,
  ChasSocialSustainability = -112
}

export enum ModuleId {
  SocialSustainability = 'ac493dd3-1131-44d4-a903-b19e00e38d08'
}

export enum PaymentMethod {
  CARD = 'Card',
  BANK_TRANSFER = 'BankTransfer'
}
